import React from 'react';
import { Link } from 'react-router-dom';

import FuseAnimate from '@fuse/core/FuseAnimate';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import { useTheme } from '@material-ui/core/styles';

function FormSubmissionsHeader({ formName, total, onExport, exportDisabled }) {
  const theme = useTheme();

  return (
    <div className="flex flex-1 w-full items-center justify-between">
      <div className="flex flex-col items-start max-w-full">
        <FuseAnimate animation="transition.slideRightIn" delay={300}>
          <Typography
            className="normal-case flex items-center mb-12"
            component={Link}
            to="/form-generator"
            color="inherit"
            role="button"
          >
            <Icon className="text-20">{theme.direction === 'ltr' ? 'arrow_back' : 'arrow_forward'}</Icon>
            <span className="mx-4">Forms</span>
          </Typography>
        </FuseAnimate>

        <FuseAnimate animation="transition.slideLeftIn" delay={300}>
          <Typography className="text-16 sm:text-20 truncate">
            {formName ? `${formName} — submissions` : 'Submissions'}
            {total ? ` (${total})` : ''}
          </Typography>
        </FuseAnimate>
      </div>

      <FuseAnimate animation="transition.slideRightIn" delay={300}>
        <Button variant="contained" color="secondary" onClick={onExport} disabled={exportDisabled}>
          Export CSV
        </Button>
      </FuseAnimate>
    </div>
  );
}

export default FormSubmissionsHeader;
